export const allPlanningClassifications = [
  // Homes
  'houses',
  'flats-apartments',
  'hmos',

  // Education
  'schools',
  'training-centres',
  'colleges',
  'universities',
  'kindergartens-nurseries-creche',

  // Community and amenity
  'community-centres',
  'libraries',
  'civic-government-buildings',
  'religious-buildings',
  'emergency-justice-buildings',
  'museums',
  'galleries',
  'public-toilets',

  // Health
  'hospitals',
  'health-clinics-surgeries',
  'dental-clinics-surgeries',
  'care-homes',
  'medical-research-facilities',
  'veterinary-clinics',
  'pharmacies',

  // Commercial
  'shops',
  'shopping-centres',
  'supermarkets',
  'offices',
  'banks-building-societies',
  'showrooms',

  // Hotels and leisure
  'hotels',
  'guest-houses',
  'restaurants',
  'cafes',
  'fast-food',
  'pubs-bars',
  'night-clubs',
  'gyms',
  'leisure-centres',
  'salons-barbers',
  'games-venues',
  'conference-exhibition-venues',

  // Outdoor sites and assets
  'stadiums',
  'outdoor-recreational-areas',
  'camp-sites-holiday-villages',

  // Agricultural / industrial
  'farms',
  'animal-buildings',
  'warehouses-storage-buildings',
  'workshops',
  'factories',
  'industrial-units',
  'distribution-depots',
  'vehicle-maintenance',
  'data-centres',
  'cold-stores-freezing-plants',
] as const

export type PlanningClassification = (typeof allPlanningClassifications)[number]
